import * as React from "react";
import {Modal, ModalBody, ModalFooter, ModalHeader} from "reactstrap";

interface IState{
    modalOpened: boolean
}

export class DirectDebitGuarantee extends React.Component<any, IState>{

    constructor(props: any) {
        super(props);

        this.state = {
            modalOpened: false
        }

        this.toggle = this.toggle.bind(this);
    }

    public render() {
        const closeBtn = <button className="btn-close" onClick={this.toggle}/>

        const onAnchorClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
            e.preventDefault();
            this.toggle();
        };

        return (
            <>
                <div>
                    <img className="card-img-bottom img-fluid license-image logo-width pt-3 pb-3"
                         src="/img/directDebitLogo.png"
                         alt="Debit card account number"
                    />
                    <p className="mb-3 font-weight-semi-bold dd-font-size">Direct Debit Instructions and Guarantee</p>
                    <p className="mb-0">Before you continue please ensure you've read the  <a className="d-inline font-weight-bold text-decoration-underline" href="#" onClick={onAnchorClick}>Direct Debit Guarantee.</a></p> { /* NOSONAR: anchor used as button due to styling constraints */ }
                    <p>
                        Please pay Liverpool Victoria Insurance Company Ltd Direct Debits from the account detailed in
                        this instruction subject
                        to the safeguards assured by the Direct Debit Guarantee.
                        I understand that this instruction may remain with Liverpool Victoria Insurance Company Ltd and
                        if so,
                        details will be passed electronically to my Bank/Building Society.
                        Bank and Building Societies may not accept Direct Debit Instructions for some types of account.
                    </p>
                </div>
                <Modal className="my-2 info-modal" isOpen={this.state.modalOpened} toggle={this.toggle}>
                    <ModalHeader toggle={this.toggle} close={closeBtn}>
                        <div className="d-flex">
                            <img className="d-block mr-3 mb-1 info-button-width" src="/img/Flow-info-selected.svg"/>
                            <div className="text-blue-2 font-weight-medium">Direct Debit Guarantee</div>
                        </div>
                    </ModalHeader>
                    <ModalBody className="pt-0">
                        <ul>
                            <li>
                                <p>
                                    This Guarantee is offered by all banks and building societies that accept instructions to pay Direct Debits
                                </p>
                            </li>
                        </ul>
                        <ul>
                            <li>
                                <p>
                                    If there are any changes to the amount, date or frequency
                                    of your Direct Debit Liverpool Victoria Insurance Company Ltd
                                    will notify you 10 working days in advance of your account being
                                    debited or as otherwise agreed. If you request Liverpool Victoria Insurance Company Ltd
                                    to collect a payment, confirmation of the amount and date will be given to you at the time of the request.
                                </p>
                            </li>
                        </ul>
                        <ul>
                            <li>
                                <p>
                                    If an error is made in the payment of your Direct Debit by Liverpool Victoria Insurance Company Ltd
                                    or your bank or building society you are entitled to a full and immediate refund of the amount paid
                                    from your bank or building society.
                                </p>
                            </li>
                        </ul>
                        <ul>
                            <li>
                                <p>
                                    If you receive a refund you are not entitled to, you must pay it back when
                                    Liverpool Victoria Insurance Company Ltd asks you to.
                                </p>
                            </li>
                        </ul>
                        <ul>
                            <li>
                                <p>
                                    You can cancel a Direct Debit at any time by simply contacting your bank or building society.
                                    Written confirmation may be required. Please also notify us.
                                </p>
                            </li>
                        </ul>
                    </ModalBody>
                    <ModalFooter className="d-flex flex-column modal-footer">
                        <button type="button" className="btn btn-primary btn-add width-md-250 mb-1 btn-next-no-arrow" onClick={this.toggle}>Ok, I understand</button>
                    </ModalFooter>
                </Modal>
            </>
        );
    }

    private toggle(): void {
        this.setState((state: IState) => ({
            modalOpened: !state.modalOpened
        }));
    }




}
